import { useState, useContext, useEffect, useRef } from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import styles from "./styles.module.css";
import SearchIcon from "images/svg/search.svg";
import SearchContext from "context/SearchContext";
import { SEARCH_ACTION_TYPES, KEYBOARD_KEYS, EVENTS } from "const";
import { eventsEmitter } from "utils/events";
import { isScanningBarcode } from "helpers/BarcodeHelper";

function ExpandableSearch() {
  const [expanded, setExpanded] = useState(false);
  const inputRef = useRef(null);

  const { searchTerm, setSearchTerm, triggerSearchAction } = useContext(SearchContext);

  const handleChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const handleKeyDown = (e) => {
    if (e.defaultPrevented || e.isHandled) return;
    if (e.key === KEYBOARD_KEYS.ARROW_DOWN) {
      e.preventDefault();
      triggerSearchAction(SEARCH_ACTION_TYPES.ARROW_DOWN);
    } else if (e.key === KEYBOARD_KEYS.ARROW_UP) {
      e.preventDefault();
      triggerSearchAction(SEARCH_ACTION_TYPES.ARROW_UP);
    } else if (e.key === KEYBOARD_KEYS.ARROW_LEFT) {
      e.preventDefault();
      triggerSearchAction(SEARCH_ACTION_TYPES.ARROW_LEFT);
    } else if (e.key === KEYBOARD_KEYS.ARROW_RIGHT) {
      e.preventDefault();
      triggerSearchAction(SEARCH_ACTION_TYPES.ARROW_RIGHT);
    } else if (e.key === KEYBOARD_KEYS.ENTER) {
      if (isScanningBarcode() || e.defaultPrevented || e.isHandled) return;
      e.preventDefault();
      triggerSearchAction(SEARCH_ACTION_TYPES.ENTER);
      if (inputRef.current) {
        inputRef.current.select();
      }
    }
  };

  useEffect(() => {
    if (searchTerm === "") {
      setExpanded(false);
    } else {
      setExpanded(true);
    }
  }, [searchTerm]);

  useEffect(() => {
    function onSearchAction(actionType) {
      if (actionType === SEARCH_ACTION_TYPES.FOCUS_SEARCH) {
        setExpanded(true);
      }
    }
    const unsubscribeFn = eventsEmitter.on(EVENTS.SEARCH_ACTION, onSearchAction);
    return unsubscribeFn;
  }, []);

  return (
    <div className={styles.searchWrap}>
      {expanded ? (
        <TextField
          autoFocus
          placeholder="Search category and menu"
          size="small"
          value={searchTerm}
          className={styles.searchInput}
          onBlur={() => {}}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          inputRef={inputRef}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton edge="end">
                  <img src={SearchIcon} alt="Search" className={styles.icon} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      ) : (
        <div className={styles.collapsedSearch} onClick={() => setExpanded(true)}>
          <img src={SearchIcon} alt="Search" className={styles.icon} />
          <span>Search (F1)</span>
        </div>
      )}
    </div>
  );
}

export default ExpandableSearch;
